/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Propeller = (props: IconProps) => (
  <Icon {...props}>
    <path d="M12 12C12 9 14.5 6.5 17.5 6.5C20.07 6.5 22.27 8.33 22.85 10.74C23 11.38 22.53 12 21.88 12H12ZM12 12C12 15 9.5 17.5 6.5 17.5C3.93 17.5 1.73 15.67 1.15 13.26C1 12.62 1.47 12 2.12 12H12ZM12 12C9 12 6.5 9.5 6.5 6.5C6.5 3.93 8.33 1.73 10.74 1.15C11.38 1 12 1.47 12 2.12V12ZM12 12C15 12 17.5 14.5 17.5 17.5C17.5 20.07 15.67 22.27 13.26 22.85C12.62 23 12 22.53 12 21.88V12Z" />
  </Icon>
);
